// src/utils/systemRedirect.js

/**
 * Monta a URL final do sistema do condomínio com query params.
 * @param {string} baseUrl - condominio.app_url
 * @param {{ token: string, user: string, role?: string, condominioID: string }} params
 * @returns {string}
 */
export function buildSystemRedirectUrl(baseUrl, { token, condominioID }) {
console.log(baseUrl)
  if (!baseUrl) throw new Error('URL do sistema não encontrada.');

  let systemUrl = baseUrl.trim();

  // adiciona https:// se não tiver protocolo
  if (!systemUrl.startsWith('http://') && !systemUrl.startsWith('https://')) {
    systemUrl = `https://${systemUrl}`;
  }

  const urlObj = new URL(systemUrl);

  urlObj.searchParams.set('token', token);
  urlObj.searchParams.set('condominio_ID', condominioID);

  return urlObj.toString();
}

export function redirectToSystem(url) {
  window.location.href = url;
}
